"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardHeaderSubItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var LeaderboardHeaderSubItem = function (_a) {
    var mainText = _a.mainText, _b = _a.secondaryText, secondaryText = _b === void 0 ? '' : _b;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'leaderboard-header--info-item--sub' }, { children: [(0, jsx_runtime_1.jsx)("span", { children: mainText }), secondaryText && (0, jsx_runtime_1.jsx)("span", { children: secondaryText })] })));
};
exports.LeaderboardHeaderSubItem = LeaderboardHeaderSubItem;
